import { render, staticRenderFns } from "./TaCheckBox.vue?vue&type=template&id=f9c75c7c&scoped=true&"
import script from "./TaCheckBox.vue?vue&type=script&lang=js&"
export * from "./TaCheckBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c75c7c",
  null
  
)

export default component.exports